export const languageList = [
    { "label": "English", "code": "en" },
    { "label": "Spanish", "code": "es" },
    { "label": "French", "code": "fr" },
    { "label": "German", "code": "de" },
    { "label": "Chinese", "code": "zh" },
    { "label": "Japanese", "code": "ja" },
    { "label": "Russian", "code": "ru" },
    { "label": "Portuguese", "code": "pt" },
    { "label": "Italian", "code": "it" },
    { "label": "Korean", "code": "ko" },
    { "label": "Arabic", "code": "ar" },
    { "label": "Hindi", "code": "hi" },
    { "label": "Dutch", "code": "nl" },
    { "label": "Swedish", "code": "sv" },
    { "label": "Turkish", "code": "tr" },
    { "label": "Polish", "code": "pl" },
    { "label": "Indonesian", "code": "id" },
    { "label": "Vietnamese", "code": "vi" },
    { "label": "Ukrainian", "code": "uk" },
    { "label": "Romanian", "code": "ro" },
    { "label": "Greek", "code": "el" },
    { "label": "Czech", "code": "cs" },
    { "label": "Hungarian", "code": "hu" },
    { "label": "Finnish", "code": "fi" },
    { "label": "Danish", "code": "da" },
    { "label": "Norwegian", "code": "no" },
    { "label": "Hebrew", "code": "he" },
    { "label": "Thai", "code": "th" },
    { "label": "Bengali", "code": "bn" },
    { "label": "Bulgarian", "code": "bg" },
    { "label": "Catalan", "code": "ca" },
    { "label": "Croatian", "code": "hr" },
    { "label": "Lithuanian", "code": "lt" },
    { "label": "Serbian", "code": "sr" },
    { "label": "Slovak", "code": "sk" },
    { "label": "Slovenian", "code": "sl" },
    { "label": "Filipino", "code": "fil" }, 
    { "label": "Afrikaans", "code": "af" },
    { "label": "Estonian", "code": "et" },
    { "label": "Basque", "code": "eu" },
    { "label": "Farsi", "code": "fa" }, 
    { "label": "Latvian", "code": "lv" },
    { "label": "Malay", "code": "ms" },
    { "label": "Swahili", "code": "sw" },
    { "label": "Tamil", "code": "ta" },
    { "label": "Telugu", "code": "te" },
    { "label": "Urdu", "code": "ur" },
    { "label": "Zulu", "code": "zu" }
];